<template>
	<div>
		<v-navigation-drawer v-model="drawer" :mini-variant="mini" app permanent>
			<v-list>
				<v-list-item link v-if="!mini">
					<v-list-item-content>
						<v-list-item-title class="title"> {{ user.firstName }} {{ user.lastName }}</v-list-item-title>
						<v-list-item-subtitle v-if="user.superuser"> Superuser</v-list-item-subtitle>
						<v-list-item-subtitle v-for="role in user.roles" :key="role.name"> {{ role.name }}</v-list-item-subtitle>
						<v-list-item-content>
							<div>
								<v-chip v-if="$socket.connected" class="ma-2" x-small color="green" text-color="white">
									Connected
								</v-chip>
								<v-chip v-else class="ma-2" x-small color="red" text-color="white">
									Disconnected
								</v-chip>
							</div>
						</v-list-item-content>
					</v-list-item-content>
				</v-list-item>
				<v-list-item link v-if="mini">
					<v-list-item-content>
						<v-icon v-if="$socket.connected" small color="green" title="Connected">mdi-checkbox-blank-circle</v-icon>
						<v-icon v-else small color="red" title="Disconnected">mdi-checkbox-blank-circle</v-icon>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-divider v-show="!mini"></v-divider>

			<v-select
				v-show="!mini"
				v-model="selectTenant"
				:items="filteredTenant"
				item-text="name"
				item-value="id"
				label="Tenant"
				return-object
				class="px-5 pt-5"
			></v-select>

			<v-divider></v-divider>

			<v-list v-if="token" nav dense>
				<v-list-item link :to="'/'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-home</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Home</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="'admins'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-account-multiple</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Administrators</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="'tenants'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-account-group</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Tenants</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="'adapterRuns'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-database-import</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Adapter Runs</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="'apiKeys'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-key-variant</v-icon>
					</v-list-item-icon>
					<v-list-item-title>API-Keys</v-list-item-title>
				</v-list-item>
				<v-list-item link :to="'adapters'">
					<v-list-item-icon>
						<v-icon color="primary">mdi-access-point</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Adapters</v-list-item-title>
				</v-list-item>
			</v-list>
			<Status class="status"></Status>
		</v-navigation-drawer>
	</div>
</template>

<style>
.status {
	position: absolute;
	bottom: 5px;
	left: 10px;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import Status from '../common/status/views/Status';

export default {
	name: 'Navigation',
	props: {
		mini: Boolean,
	},
	components: {
		Status,
	},
	data: () => ({
		drawer: false,
	}),
	computed: {
		...mapState({
			user: state => state.auth.user,
			tenant: state => state.tenant.tenant,
			tenants: state => state.tenant.tenants,
			token: state => state.auth.token,
		}),

		filteredTenant() {
			return this.tenants?.filter(item => item.deleted === false);
		},

		selectTenant: {
			get() {
				return this.tenant;
			},
			async set(value) {
				await this.changeTenant({ newTenant: value });

				//Refresh page after tenant was changed
				this.$router.go();
			},
		},
	},
	methods: {
		...mapActions({
			changeTenant: 'tenant/changeTenant',
			loadTenant: 'tenant/load',
		}),
	},
	mounted() {
		this.loadTenant();
	},
};
</script>
